<template>
  <div class="form-panel">
    <p class="form-panel__title"><i class="mdi mdi-filter-variant"></i>Interpolação de ordenhas</p>
    <v-autocomplete
      class="form-panel__field"
      outlined
      dense
      label="Criador"
      :items="computedCreators"
      item-text="name"
      item-value="id"
      @change="getAnimals"
      v-model="filter.person"
      no-data-text="Nenhum Resultado"
    ></v-autocomplete>

    <div
      class="form-panel__field form-panel__field--wide"
      :class="filter.animals.length > 6 ? 'resize-autocomplete' : ''"
    >
      <v-autocomplete
        outlined
        dense
        label="Animais"
        :items="animals"
        item-text="name_code"
        item-value="id"
        v-model="filter.animals"
        multiple
        no-data-text="Nenhum Resultado"
      >
        <template v-slot:prepend-item>
          <v-list-item ripple @click="selectAllAnimals">
            <v-list-item-action>
              <v-icon
                :color="
                  filter.animals.length > 0 ? 'indigo darken-4' : ''
                "
              >
                {{ icon }}
              </v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                Selecionar todos
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider class="mt-2"></v-divider>
        </template>
      </v-autocomplete>
    </div>

    <div class="form-panel__actions">
      <v-btn
        class="success"
        :disabled="!filter.animals || !filter.animals.length"
        @click="submit"
      >
        <i class="mdi mdi-file-chart-outline pr-1"></i>
        Gerar Relatório
      </v-btn>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
export default {
  name:"ReportFilters",
  props:{
    creators:Array,
  },
  data() {
    return {
      filter:{
        animals:[]
      },
      animals:[]
    }
  },
  computed:{
    ...mapState("farms", ["farms"]),
    computedAnimals: {
      get() {
        return this.animals;
      },
      set(newValue) {
        this.animals = newValue;
      }
    },
    computedCreators() {
      return this.creators.map(e => ({...e, name:e.code_integration + " - " + e.name}))
    },
    likesAllAnimals() {
    return this.filter.animals.length === this.computedAnimals.length;
    },
    likesSomeAnimals() {
      return this.filter.animals.length > 0 && !this.likesAllAnimals;
    },
    icon() {
      if (this.likesAllAnimals) return "mdi-close-box";
      if (this.likesSomeAnimals) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  methods: {
    ...mapActions("animals", ["actionGetAnimalsReleased"]),
    ...mapActions("farms", ["actionGetFarms"]),
    submit() {
      this.$emit("get-report", this.filter);
    },
    async getAnimals(id) {
      if(id) {
        this.computedAnimals = [];
        await this.actionGetFarms(id);
        for(let i = 0; i < this.farms.length; i++) {
          const results = await this.actionGetAnimalsReleased({headers:{farm:this.farms[i].id}});
          this.computedAnimals.push(
            {header:this.farms[i].name},
            ...results.map(e => ({...e, name_code:e.code + " - " + e.register + " - " + e.name}))
          )
        }
      }
    },
    selectAllAnimals() {
      this.$nextTick(() => {
        let all = null;
        if (this.likesAllAnimals) {
          this.filter.animals = [];
        } else {
          all = this.computedAnimals.map(e => {return e.id});
          this.filter.animals = all.slice();
        }
      });
    },
  }
}
</script>